import { render, staticRenderFns } from "./app-popup.vue?vue&type=template&id=af3605fe&"
import script from "./app-popup.vue?vue&type=script&lang=js&"
export * from "./app-popup.vue?vue&type=script&lang=js&"
import style0 from "./app-popup.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports